export default [
    function () {
        return {
            restrict: 'E',
            scope: {
                loadingText: '@',
                loadingHeight: '@',
            },
            template: require('./flexSpinner.html'),
            controller: InlineSpinnerController,
        };
    },
];

InlineSpinnerController.$inject = ['$scope'];

function InlineSpinnerController($scope) {
    init();

    function init() {
        if (!$scope.loadingText) {
            $scope.loadingText = 'Loading';
        }
        if (!$scope.loadingHeight) {
            $scope.loadingHeight = 'auto';
        }
    }
}
